


export default function Caracteres()
{
    return (
        <div className='Page'>
            <h1>Les caractères</h1>

            <p>
                Sur VG5000 nous disposons de base de 5 jeux de caractères que vous pourrez choisir à loisir pour vos applications.<br/>
                Ces jeux de caractères contiennent essentiellement des caractères alphanumériques mais pas seulement.
            </p>

            <p>
                <ul>
                    <li>Le jeu de base est appelé G0. Il contient 128 caractères alphanumériques.</li>
                    <li>Le jeu G10 est le jeu de caractères semi-graphique. Il est lui-même séparé en deux jeux de 64 caractères nommés “mosaïques” et “séparés”.</li>
                    <li>Le jeu G11 qui lui est un peu particulier puisque composé de diagonales de de médianes.</li>
                    <li>Les jeux G20 et G21 que nous pouvons considérer comme complémentaires puisque le premier contient les lettres minuscules tandis que le deuxième contient un jeu de 8 accents et cédilles.<br/>
                    Les deux se superposent pour former des lettres accentuées.</li>
                </ul>
            </p>

            <p>
                Comme le but de cet article n'est pas de vous expliquer comment afficher ces caractères, vous trouverez leurs différentes tables dans la documentation.
            </p>

        </div>
    )
}